import React, { useState, useEffect } from "react";
import {
  Chart,
  Settings,
  BarSeries,
  Axis,
  Position,
  Tooltip,
  DARK_THEME,
  LIGHT_THEME,
  ScaleType,
} from "@elastic/charts";
import Loader from "../../../shared/Loader";
import { useTheme } from "../../../../context/ThemeContext";
import StatsService from "../../../../services/v2/outbound/stats-service";

const TimeAveragesPerQueue = ({ filters }) => {
  const [data, setData] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const { isDarkMode } = useTheme();

  // Convertir mm:ss a segundos
  const timeToSeconds = (time) => {
    const [minutes, seconds] = time.split(":").map(Number);
    return minutes * 60 + seconds;
  };

  // Convertir segundos a mm:ss para etiquetas
  const secondsToTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  useEffect(() => {
    setLoading(true);
    setError(false);
    StatsService.timeAveragesPerAgent(filters)
      .then(({ data: { data } }) => {
        // Transformar los datos
        const transformedData = data
          .map((agent) => [
            {
              x: agent.agent,
              y: timeToSeconds(agent.avgDurationTime),
              g: "Duration Time",
            },
            {
              x: agent.agent,
              y: timeToSeconds(agent.avgRingingTime),
              g: "Ringing Time",
            },
          ])
          .flat();

        setData(transformedData);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setError(true);
        setLoading(false);
      });
  }, [filters]);

  if (isLoading)
    return (
      <div className="flex items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  if (error)
    return (
      <div className="flex items-center justify-center w-full h-full">
        <div className="text-red-500 text-sm font-semibold text-center">
          Some error occurred loading data
        </div>
      </div>
    );

  return (
    <div className={`w-full h-full ${isDarkMode ? "dark-legend" : ""}`}>
      <Chart size="100%">
        <Settings
          showLegend={true}
          rotation={90}
          legendPosition="left"
          baseTheme={isDarkMode ? DARK_THEME : LIGHT_THEME}
          theme={{
            background: {
              color: isDarkMode ? "#1A202C" : "#ffffff",
            },
            axes: {
              tickLine: {
                stroke: isDarkMode ? "#ffffff" : "#000000",
              },
              tickLabel: {
                fill: isDarkMode ? "#ffffff" : "#000000",
              },
            },
          }}
        />
        <Tooltip
          style={{
            backgroundColor: isDarkMode ? "#1f2937" : "#ffffff",
            color: isDarkMode ? "#ffffff" : "#000000",
            border: `1px solid ${isDarkMode ? "#4B5563" : "#E5E7EB"}`,
          }}
        />
        <BarSeries
          id="time-averages-per-queue"
          xScaleType={ScaleType.Ordinal}
          yScaleType={ScaleType.Linear}
          xAccessor="x" // Eje X (Nombre de la cola)
          yAccessors={["y"]} // Valores (Tiempos promedios en segundos)
          stackAccessors={"x"}
          splitSeriesAccessors={["g"]} // División por tipo (Ringing Time / Duration Time)
          data={data}
        />
        <Axis
          id="bottom-axis"
          position={Position.Bottom}
          showOverlappingTicks
          tickLabelStyle={{
            fill: isDarkMode ? "#ffffff" : "#000000", // Etiquetas del eje X
          }}
        />
        <Axis id="left-axis" position={Position.Left} />
      </Chart>
    </div>
  );
};

export default TimeAveragesPerQueue;
